export default __webpack_public_path__ + "static/media/03_DAIF_Eco_02_AMD.e3e6c628.mp4";